module.exports = __webpack_public_path__ + "static/media/vbelt.6113ad55.jpg";